import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'tanok';
import classSet from 'classnames';

import {
    getRoom,
    CHAT_STATUS_ACTIVE,
    REGISTRY_STATUS_ACTIVE,
    REGISTRY_STATUS_INACTIVE,
    REGISTRY_STATUS_OFFLINE,
} from '@evo/chat-core';

import * as a from '../../../../libs/actions';
import * as aggr from '../../../../libs/aggregation';
import { getSocketStore } from '../../../../libs/utils';
import { toJS } from '../../../helpers/ImmutableToJS';
import {
    getChatsStatusText,
    CHATS_STATUSES
} from '../../../../libs/helpers';

import { Title } from './title';
import { Head } from '../../../ui/head';

// styles
import css from './chatHeader.sss';


class HeaderView extends React.Component {
    static propTypes = {
        isInDialog: PropTypes.bool,
        currentRoomName: PropTypes.any,
        currentChatRoom: PropTypes.any,
        newMsgInCurrentDialog: PropTypes.any,
        newMsgMarkShown: PropTypes.bool,
        hasUnreadMessage: PropTypes.bool,
        closeDialog: PropTypes.func,
        backToChatList: PropTypes.func,
        responseMedian: PropTypes.any,
        selectedChatStatusText: PropTypes.string,
        chatsStatuses: PropTypes.array,
    };

    handleChatsStatusChange = (event) => {
        const value = event.target.value;
        return this.props.send(a.EVENT_CHATS_STATUS_CHANGE, {status: value});
    }

    renderDialogHead = () => {
        const {
            backToChatList, newMsgInCurrentDialog, newMsgMarkShown,
            currentRoomName, currentChatRoom, hasUnreadMessage
        } = this.props;


        const status = currentChatRoom.status;

        const indicatorClasses = classSet(
            css.indicator,
            {
                [css.indicatorActive]: status === REGISTRY_STATUS_ACTIVE,
                [css.indicatorInactive]: status === REGISTRY_STATUS_INACTIVE,
                [css.indicatorOffline]: status === REGISTRY_STATUS_OFFLINE,
            },
        );

        return (
            <Head
                dataQa='chat_header'
                hasUnreadMessage={hasUnreadMessage}
                onBack={backToChatList(newMsgInCurrentDialog, newMsgMarkShown)}
            >
                {currentRoomName && (
                    <div className={css.dialogHolder}>
                        <div className={css.dialogTitle}>
                            <div
                                className={indicatorClasses}
                                key='chat-indicator-block'
                                data-online
                            />
                            <div className={css.title}>
                                <Title />
                            </div>
                        </div>
                    </div>
                )}
            </Head>
        );
    }

    renderListHead = () => {
        const { selectedChatStatusText, chatsStatuses, closeDialog } = this.props;

        const actions = [];
        for (let i = 0; i < chatsStatuses.length; ++i) {
            actions[i] = {
                value: chatsStatuses[i],
                title: getChatsStatusText(chatsStatuses[i]),
            }
        }

        return (
            <Head
                dataQa='chat_header'
                actions={actions}
                onBack={closeDialog}
                onSelectAction={this.handleChatsStatusChange}
            >
                {selectedChatStatusText}
            </Head>
        );
    }

    render() {
        const { isInDialog } = this.props;
        return isInDialog ? this.renderDialogHead() : this.renderListHead();
    }
}

const mapStateToProps = (state) => {
    const socketStore = getSocketStore(state);
    const currentChatRoom = getRoom(socketStore, state.get('openedRoomIdent'));

    const selectedChatStatusText = getChatsStatusText(state.get('chatsStatus'));
    return {
        newMsgMarkShown: state.get('newMsgMarkShown'),
        isNewCabinet: state.get('isNewCabinet'),
        isInDialog: aggr.isInDialog(currentChatRoom),
        newMsgInCurrentDialog: aggr.newMsgInCurrentDialog(currentChatRoom),
        responseMedian: currentChatRoom.get('response_median') || '',
        currentRoomName: currentChatRoom.get('room_name'),
        locale: state.get('locale'),
        userRole: state.get('userRole'),
        userHasCompany: state.get('userHasCompany'),
        userHasC2CCompany: state.get('userHasC2CCompany'),
        selectedChatStatusText,
        currentChatRoom,
        chatsStatuses: CHATS_STATUSES,
        hasUnreadMessage: aggr.hasUnreadMessage(
            socketStore.get('chats'),
            CHAT_STATUS_ACTIVE
        )
    };
};

export const Header = connect(mapStateToProps)(toJS(HeaderView));
